import { Component, type ReactNode } from 'react';

/** No automatic retries: a failed page load must not repeat a business mutation. */
export class WorkspaceRecovery extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main style={{ maxWidth: 560, margin: '12vh auto', padding: 32 }} role="alert">
        <h1>The workspace could not load.</h1>
        <p>
          Check your connection, then reload. If you had just submitted a change, check its saved
          status before trying it again.
        </p>
        <button className="btn btn-primary" onClick={() => window.location.reload()}>
          Reload workspace
        </button>
        <p>
          Your saved CRM records remain on the server. Unsaved edits may need to be entered again.
        </p>
      </main>
    );
  }
}
